import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'formly-list',
    templateUrl: "./formly-list.component.html",
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormlyModule, TranslateModule]
})
export class FormlyListComponent extends FieldType implements OnInit, OnDestroy {

  isFormSubmitted: boolean = false;
  formSubmissionSubscription: Subscription;
  fieldKey: string;

  listOptions: any;

  constructor(private dynamicFormService: DynamicFormService) {
    super();
  }

  ngOnInit() {
    if (this.field.key) {
      this.fieldKey =this.field.id??this.field.key.toString();
    }
    this.listOptions = this.to.options;
    this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
      this.isFormSubmitted = data;
    });
  }

  ngOnDestroy() {
    if (this.formSubmissionSubscription) {
      this.formSubmissionSubscription.unsubscribe();
    }
  }

  onClick(item) {
    this.model[this.field.key.toString()] = item.key;
    if (this.to.click) {
      this.to.click(this, item.key);
    }
  }

}